import { apiService } from './api';

export interface BackupRecord {
  id: string;
  name: string;
  type: 'FULL' | 'PARTIAL' | 'INCREMENTAL';
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  size: number;
  createdAt: string;
  completedAt?: string;
  description?: string;
  tables: string[];
  recordCount: number;
}

class BackupService {
  async list(): Promise<{ backups: BackupRecord[] }> {
    return apiService.get('/backup');
  }

  async create(payload?: { type?: 'FULL' | 'PARTIAL' | 'INCREMENTAL'; tables?: string[]; name?: string; description?: string; }): Promise<{ message: string; backup: BackupRecord }> {
    return apiService.post('/backup', payload || { type: 'FULL' });
  }

  async download(id: string): Promise<Blob> {
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/backup/download/${id}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Download failed');
    return response.blob();
  }

  async remove(id: string): Promise<{ message: string }> {
    return apiService.delete(`/backup/${id}`);
  }

  async restore(id: string): Promise<{ message: string }> {
    return apiService.post(`/backup/restore/${id}`, {});
  }
}

export const backupService = new BackupService();

